import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import {
    IGroup,
    IGroupElement,
    IGroupMember,
    IGroupType,
    IGroupElementType
} from '../IGroups';
import * as actions from './actions';
import { ResponseStatus, DisplayMessageMinimum } from '../../shared';

export interface State {
    groups: Array<IGroup>;
    groupMembers: Array<IGroupMember>;
    groupElements: Array<IGroupElement>;
    groupElementTypes: Array<IGroupElementType>;
    groupTypes: Array<IGroupType>;
    errors: Array<string>;
}

export const initialState: State = {
    groups: [],
    groupMembers: [],
    groupElements: [],
    groupElementTypes: [],
    groupTypes: [],
    errors: []
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): State {
    switch (action.type) {
        case actions.ActionTypes.Reset:
            return initialState;
        case actions.ActionTypes.SetGroups:
            return {
                ...state,
                groups: [...action.payload]
            };
        case actions.ActionTypes.SetGroupMembers:
            return {
                ...state,
                groupMembers: [...action.payload]
            };
        case actions.ActionTypes.SetGroupElements:
            return {
                ...state,
                groupElements: [...action.payload]
            };
        case actions.ActionTypes.SetGroupTypes:
            return {
                ...state,
                groupTypes: [...action.payload]
            };
        case actions.ActionTypes.SetGroupElementTypes:
            return {
                ...state,
                groupElementTypes: [...action.payload]
            };
        case actions.ActionTypes.UpdateGroupsSuccess:
            const gresp = action.payload;
            return {
                ...state,
                groups: state.groups
                    // problem here when the dftid for multiple rows is -1
                    .map<IGroup>(
                        x =>
                            gresp.Items.find(y => y.GroupID === x.GroupID) || {
                                ...x
                            }
                    ) // update any existing
                    .concat(
                        gresp.Items.filter(
                            x =>
                                !state.groups.find(y => y.GroupID === x.GroupID)
                        )
                    ), // add any new
                errors: gresp.ErrorMessages
            };
        case actions.ActionTypes.UpdateGroupMembersSuccess:
            const gmresp = action.payload;
            return {
                ...state,
                groupMembers: state.groupMembers
                    // problem here when the dftid for multiple rows is -1
                    .map<IGroupMember>(x => {
                        const updated = gmresp.Items.find(
                            y => y.ListID === x.ListID
                        );
                        if (!updated) {
                            return { ...x };
                        }
                        return {
                            ...updated,
                            IsPrimary:
                                updated.IsPrimary != null
                                    ? updated.IsPrimary
                                    : x.IsPrimary
                        };
                    }) // update any existing
                    .concat(
                        gmresp.Items.filter(
                            x =>
                                !state.groupMembers.find(
                                    y => y.ListID === x.ListID
                                )
                        )
                    ), // add any new
                errors: gmresp.ErrorMessages
            };
        case actions.ActionTypes.UpdateGroupElementsSuccess:
            const geresp = action.payload;
            return {
                ...state,
                groupElements: state.groupElements
                    // problem here when the dftid for multiple rows is -1
                    .map<IGroupElement>(
                        x =>
                            geresp.Items.find(
                                y => y.GroupElementID === x.GroupElementID
                            ) || {
                                ...x,
                                Status: {
                                    StatusCode: 0,
                                    Message: undefined,
                                    MsgProcessID: 0,
                                    MsgEntityID: ''
                                }
                            }
                    ) // update any existing
                    .concat(
                        geresp.Items.filter(
                            x =>
                                !state.groupElements.find(
                                    y => y.GroupElementID === x.GroupElementID
                                )
                        )
                    ), // add any new
                errors: geresp.ErrorMessages
            };
        case actions.ActionTypes.DeleteGroupSuccess:
            const deleresp = action.payload;
            return {
                ...state,
                groups: state.groups, // need to remove the deleted group from the state
                errors: [
                    ...deleresp.ErrorMessages,
                    ...deleresp.Items.filter(
                        x => x.Status.StatusCode >= DisplayMessageMinimum
                    ).map(x => x.Status.Message)
                ]
            };
        default:
            return state;
    }
}
const StateFeatureSelector = createFeatureSelector<State>('groups');

export const getGroups = createSelector(StateFeatureSelector, x => x.groups);
export const getGroupMembers = createSelector(
    StateFeatureSelector,
    x => x.groupMembers
);
export const getGroupElements = createSelector(
    StateFeatureSelector,
    x => x.groupElements
);
export const getGroupElementTypes = createSelector(
    StateFeatureSelector,
    x => x.groupElementTypes
);
export const getGroupTypes = createSelector(
    StateFeatureSelector,
    x => x.groupTypes
);
export const getGroupsErrors = createSelector(
    StateFeatureSelector,
    x => x.errors
);
